import { createContext, Dispatch, SetStateAction } from 'react';

export type MixPanelContextType = {
  isMixPanelInitialized: boolean;
  setIsMixPanelInitialized: Dispatch<SetStateAction<boolean>>;
};

const MixPanelContext = createContext<MixPanelContextType>({
  isMixPanelInitialized: false,
  setIsMixPanelInitialized: () => {},
});

export default MixPanelContext;
